﻿'use strict';

/**
 * @ngdoc function
 * @name ntmApp.controller:GeneralPageController
 * @description
 * # GeneralPageController
 * Controller of the ntmApp
 */
angular.module('ntmApp')
  .controller('GeneralPageController', ['$scope', '$rootScope', '$routeParams', 'EditForm', 'FormService', 'MainMenu', 'FlashService', 'ListGridConstants',
    function ($scope, $rootScope, $routeParams, EditForm, FormService, MainMenu, FlashService, ListGridConstants) {

      function init() {
          $scope.dataLoaded = false;
          FlashService.ShowProgressBar();
		  
		  var data = {
			  id: $routeParams.id
		  };

          FormService.GetForm(data).then(function (result) {
			  
			  result.data.action = ListGridConstants.Operation.INSERT;
			  result.data.pageType = ListGridConstants.SectionType.GeneralPage;

              $scope.editForm = new EditForm(result.data);
              $scope.dataLoaded = true;
              FlashService.HideProgressBar();
          });
      }

      init();
      
  }]);